import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import get from 'lodash/get'

import Button from 'discada/dist/Button'

import TradePendingReport from 'components/Quote/TradePendingReport'
import TradePendingSearch from 'components/Quote/TradePendingSearch'
import { getPermission } from 'selectors/authSelectors'

import Menuing from 'components/widgets/Menuing'
import QV from 'components/Quote/QuoteValue'
import { addItem, removeItem } from 'actions/quoteActions'
import { getQuoteValue } from 'selectors/quoteSelectors'
import { getTPDealerID } from 'selectors/appStatusSelectors'

import './Trades.scss'

export class Trade extends React.Component {
  state = { visible: false }

  componentDidMount() {
    setTimeout(() => this.setState({ visible: true }), 100)
  }

  render() {
    let {
        vehicleId,
        quoteId,
        className,
        trade,
        tradeIndex,
        removeItem,
        showAcv,
        tradeKey,
      } = this.props,
      { visible } = this.state,
      tpVehicle = get(trade, 'tradePending.vehicle', {}),
      i = tradeIndex,
      labelRenderer = c => <span>{c.label}</span>,
      valueRenderer = c => (
        <React.Fragment>
          {c.control}
          {!c.noValue && !c.hide && (
            <QV
              vehicleId={vehicleId}
              quoteId={quoteId}
              value={c.value || null}
              k={c.valueKey ? `trades[${i}].${c.valueKey}` : null}
              type={c.type}
              readOnly={c.readOnly}
              permit={c.permit}
            />
          )}
        </React.Fragment>
      )

    return (
      <div
        className={c(
          'trade-input',
          `trade-input-${tradeKey}`,
          'snap-typeahead',
          className,
          { 'trade-selected': !!tpVehicle.ymmt, visible },
        )}
      >
        <div className="tp-fields border">
          <div className="tp-fields-inner">
            <div className="tp-user-inputs">
              <div className="vehicle-input">
                <span className="vehicle-input-inner">
                  <TradePendingSearch
                    vehicleId={vehicleId}
                    quoteId={quoteId}
                    tradeIndex={tradeIndex}
                    tradeKey={tradeKey}
                  />
                </span>
              </div>
              <div className="www">
                <div>
                  <Menuing
                    items={[
                      {
                        label: 'How many miles does it have?',
                        valueKey: 'mileage',
                        type: 'number',
                        permit: 'customize',
                      },
                    ]}
                    labelRenderer={labelRenderer}
                    valueRenderer={valueRenderer}
                  />
                </div>

                <div className="tp-fields">
                  <Menuing
                    items={[
                      {
                        label: showAcv
                          ? 'Allowance'
                          : 'What do you want for it?',
                        valueKey: 'allowance',
                        type: 'money',
                        permit: 'customize',
                        size: 'small',
                      },
                      {
                        label: showAcv ? 'Payoff' : 'Anything left to pay off?',
                        valueKey: 'payoff',
                        type: 'money',
                        permit: 'customize',
                        size: 'small',
                      },
                      /*{*/
                      //label: 'Net Trade-in Value',
                      //value: money(allowance - payoff),
                      //readOnly: true,
                      //type: 'money',
                      //size: 'small',
                      /*},*/
                      {
                        label: 'ACV',
                        valueKey: 'acv',
                        type: 'money',
                        className: 'internal acv',
                        hide: !showAcv,
                        size: 'small',
                      },
                    ]}
                    labelRenderer={labelRenderer}
                    valueRenderer={valueRenderer}
                  />
                </div>
              </div>
              <div>
                <Button
                  text
                  tabIndex="-1"
                  size="small"
                  className="remove"
                  onClick={() =>
                    removeItem(vehicleId, quoteId, tradeIndex, 'trades')
                  }
                >
                  remove trade
                </Button>
              </div>
            </div>
            <TradePendingReport
              vehicleId={vehicleId}
              quoteId={quoteId}
              tradeIndex={tradeIndex}
            />
          </div>
        </div>
      </div>
    )
  }
}

export function Trades(props) {
  let { addItem, className, vehicleId, quoteId, trades } = props

  return (
    <div className={c('trades', className)}>
      {trades.map((t, i) => (
        <Trade
          {...props}
          trade={t}
          tradeIndex={i}
          key={t.key || i}
          tradeKey={t.key || i}
        />
      ))}

      <Button
        primary
        icon="plus"
        size="small"
        className="add-trade"
        onClick={() => addItem(vehicleId, quoteId, 'trades')}
      >
        Add a Another Trade-In
      </Button>
    </div>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    trades: getQuoteValue(state, op.vehicleId, op.quoteId, 'trades', []),
    internal: getPermission(state, 'deal.fields/profit'),
    zipCode: getQuoteValue(state, op.vehicleId, op.quoteId, 'customerZipCode'),
    tpDealerId: getTPDealerID(state),
  }
}

export default connect(
  mapStateToProps,
  { addItem, removeItem },
)(Trades)
